import { render } from "./Predictions.vue?vue&type=template&id=37fbec38&scoped=true"
import script from "./Predictions.vue?vue&type=script&lang=js"
export * from "./Predictions.vue?vue&type=script&lang=js"

import "./Predictions.vue?vue&type=style&index=0&id=37fbec38&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fbec38"]])

export default __exports__